export default class Newsletter {
    constructor() {
        const emailButtons = Array.from(document.querySelectorAll('.email-open'));
        emailButtons.forEach(function(emailButton) {
            emailButton.addEventListener('click', function(event) {
                event.stopPropagation
                if (this.classList.contains('active')) {
                    return;
                } else {
                    this.classList.add('active');
                }
            });
        });
        

    }
  }
  new Newsletter();